module.exports = __webpack_public_path__ + "media/images/hbd-2f85a81e7335508dcb90ed5288ac067e.png";